import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { OrderEntry, ReelCutting, ReelCuttingRequest } from '../../../../core/model';
import { Occ } from '../../../../core/occ/occ-models';
import { ConverterService } from '../../../../core/util';
import { REEL_CUTTING_NORMALIZER } from './converters';

@Injectable({
  providedIn: 'root',
})
export class CartEntryReelCuttingConnector {
  constructor(
    private httpClient: HttpClient,
    private occEndpointsService: OccEndpointsService,
    private converterService: ConverterService
  ) {}

  add(userId: string, cartId: string, entry: OrderEntry, reelCutting: ReelCuttingRequest): Observable<any> {
    const url = this.occEndpointsService.buildUrl('cartEntryReelCutting', {
      urlParams: {
        userId: userId,
        cartCodeOrType: cartId,
        entryNumber: `${entry.entryNumber}`,
      },
    });
    return this.httpClient.put(url, reelCutting);
  }

  remove(userId: string, cartId: string, entry: OrderEntry): Observable<any> {
    const url = this.occEndpointsService.buildUrl('cartEntryReelCutting', {
      urlParams: {
        userId: userId,
        cartCodeOrType: cartId,
        entryNumber: `${entry.entryNumber}`,
      },
    });
    return this.httpClient.delete(url);
  }

  calculatePrice(userId: string, cartId: string, entry: OrderEntry, reelCutting: ReelCuttingRequest): Observable<ReelCutting> {
    const url = this.occEndpointsService.buildUrl('cartEntryReelCuttingPrice', {
      urlParams: {
        userId: userId,
        cartCodeOrType: cartId,
        entryNumber: `${entry.entryNumber}`,
      },
      queryParams: {
        daughterLength: reelCutting.daughterLength,
        daughterWidths: reelCutting.daughterWidths.join(','),
        remainder: reelCutting.remainder,
      },
    });
    return this.httpClient.get<Occ.ReelCutting>(url).pipe(this.converterService.pipeable(REEL_CUTTING_NORMALIZER));
  }
}
